import { Order, StateUtils } from '@spartacus/core';
import { ORDER_DETAILS } from '../order-state';

export const ONLINE_ORDER_DETAILS_LOAD = '[Order] Online Order Details Load';
export const OFFLINE_ORDER_DETAILS_LOAD = '[Order] Offline Order Details Load';
export const ONLINE_ORDER_DETAILS_LOAD_FAIL = '[Order] Online Order Details Load Fail';
export const ONLINE_ORDER_DETAILS_LOAD_SUCCESS = '[Order] Online Order Details Load Success';
export const ONLINE_ORDER_DETAILS_CLEAR = '[Order] Online Order Details Clear';

export class OnlineOrderDetailsLoad extends StateUtils.LoaderLoadAction {
  readonly type = ONLINE_ORDER_DETAILS_LOAD;

  constructor(
    public payload: {
      orderCode: string;
    },
  ) {
    super(ORDER_DETAILS);
  }
}

export class OfflineOrderDetailsLoad extends StateUtils.LoaderLoadAction {
  readonly type = OFFLINE_ORDER_DETAILS_LOAD;

  constructor(
    public payload: {
      orderCode: string;
    },
  ) {
    super(ORDER_DETAILS);
  }
}

export class OnlineOrderDetailsLoadFail extends StateUtils.LoaderFailAction {
  readonly type = ONLINE_ORDER_DETAILS_LOAD_FAIL;

  constructor(public payload: any) {
    super(ORDER_DETAILS, payload);
  }
}

export class OnlineOrderDetailsLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = ONLINE_ORDER_DETAILS_LOAD_SUCCESS;

  constructor(public payload: Order) {
    super(ORDER_DETAILS);
  }
}

export class OnlineOrderDetailsClear extends StateUtils.LoaderResetAction {
  readonly type = ONLINE_ORDER_DETAILS_CLEAR;

  constructor() {
    super(ORDER_DETAILS);
  }
}

export type OnlineOrderDetailsActions =
  | OnlineOrderDetailsLoad
  | OfflineOrderDetailsLoad
  | OnlineOrderDetailsLoadFail
  | OnlineOrderDetailsLoadSuccess
  | OnlineOrderDetailsClear;
